import React from 'react';
import { LayoutProps, MarginProps } from '../../../../theme/styledProps';
import { Text } from '../../Text/Text';
import { Button } from '../../Button/Button';
import { Box } from '../../Box/Box';

export interface ErrorStateProps extends MarginProps, LayoutProps {
  title?: string;
  message?: string;
  actionTitle?: string;
  onAction?(): void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  title = 'Whoops!',
  message = 'Sorry, something went wrong. Please try again.',
  actionTitle = 'Try Again',
  onAction,
  ...rest
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      {...rest}
    >
      <Text as="h6" fontSize="h6" fontWeight={600} mb="8">
        {title}
      </Text>

      <Text color="neutral.500" mb="16" textAlign="center">
        {message}
      </Text>

      {onAction && (
        <Button variant="primary" onClick={onAction}>
          {actionTitle}
        </Button>
      )}
    </Box>
  );
};
